import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import PhaseActions from 'store/redux/phase'
import { SectionSelectors, SectionAllCards, SubSectionPreRaceCardsGroup, SectionPreRaceCircuitPanel, Text } from 'components'
import PHASE from 'utils/constants/phases'
import ITEM from 'utils/constants/items'
import { capitalize } from 'utils/string'
import DATA_SELECTORS from 'data/selectors'
import { translate } from 'react-i18next'
import { find } from 'lodash'
import { Phase } from '../Phase'
import './PreRace.css'

@pageData({ title: 'PreRace' })
@connect(
    state => ({
        phase: state.phaseInfo.phase,
        initialAvailableCredits: state.phaseInfo.credits,
        credits: state.phase.credits,
        selection: state.phase.selection,
        currentSeason: state.phaseInfo.season,
        currentRace: state.phaseInfo.race,
        totalRaces: state.phaseInfo.totalRaces,
        preRaceData: state.phaseInfo.data,
        isAMToolActive: state.phase.isAMToolActive,
        curvesParams: state.phaseInfo.performanceOverDeteriorationCurveParams,
        currentSelection: state.phaseInfo.currentSelection
    }),
    {
        setCredits: PhaseActions.setCredits,
        updateSelection: PhaseActions.updatePreRaceSelection
    }
)
@translate()
export class PreRace extends PureComponent {
    state = {
        selectedSelectorId: null,
        showAMToolPanel: false,
        allowPurchaseUnitsInDebt: false
    }

    componentWillMount() {
        const { currentSeason, currentRace, preRaceData, t } = this.props
        this.selectors = DATA_SELECTORS[PHASE.PRE_RACE]
        this.refreshPhaseData(this.props)
        this.interTitles = [
            {
                image: 'start',
                title: capitalize(t('game.PRE_RACE.interTitleStart.title', { race: currentRace })),
                text: t('game.PRE_RACE.interTitleStart.text', { season: currentSeason })
            }
        ]
        if (currentRace > 1) {
            this.interTitles = [
                {
                    image: 'finish',
                    title: capitalize(t('game.PRE_RACE.interTitleFinishPrevious.title', { race: currentRace - 1 })),
                    text: t('game.PRE_RACE.interTitleFinishPrevious.text', { season: currentSeason })
                },
                ...this.interTitles
            ]
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.phase === PHASE.PRE_RACE) {
            if (nextProps.preRaceData !== this.props.preRaceData) {
                this.refreshPhaseData(nextProps)
            }
        }
        if (nextProps.isAMToolActive !== this.props.isAMToolActive) {
            this.setState({ showAMToolPanel: nextProps.isAMToolActive })
        }
    }

    setPhaseRef = ref => {
        this.phaseRef = ref
    }

    handleToggleAMToolPanel = () => this.setState({ showAMToolPanel: this.props.isAMToolActive && !this.state.showAMToolPanel })

    refreshPhaseData = props => {
        const { phase, preRaceData, initialAvailableCredits, selection } = props
        if (phase === PHASE.PRE_RACE) {
            // if there's something selected, we set selectedSelectorId
            this.setState({ selectedSelectorId: (find(this.selectors, ({ id }) => !!selection[id]) || {}).id || null })
            // if there's something selected, we update the icons for each selection
            this.selectors = this.selectors.map(({ id, icon, ...selector }) => {
                const selectedOption = selection[id] ? find(preRaceData[id], o => o.id === selection[id]) : undefined
                return {
                    id,
                    icon: selectedOption ? selectedOption.icon : icon,
                    ...selector,
                }
            })
            // updates the data
            this.selectorsIds = this.selectors.map(({ id }) => id)
            const pitStopPrices = preRaceData[ITEM.PRE_RACE_PITSTOPS].prices
            this.cardsData = [
                {
                    groupId: ITEM.PRE_RACE_WHEELS,
                    cards: preRaceData[ITEM.PRE_RACE_WHEELS].map(option => ({ ...option, typeId: option.id }))
                },
                {
                    groupId: ITEM.PRE_RACE_DRIVING,
                    cards: preRaceData[ITEM.PRE_RACE_DRIVING].map(option => ({ ...option, typeId: option.id }))
                },
                {
                    groupId: ITEM.PRE_RACE_PITSTOPS,
                    cards: [
                        {
                            typeId: ITEM.PRE_RACE_PITSTOPS,
                            icon: 'pitstops',
                            prices: pitStopPrices,
                            priceInDebt: preRaceData[ITEM.PRE_RACE_PITSTOPS].priceFIA || pitStopPrices[0],
                            unitsLeftAsNormalPrice: Math.floor(initialAvailableCredits / pitStopPrices)
                        }
                    ]
                }
            ]
        }
    }

    handleSelectSelector = id => {
        this.setState({ selectedSelectorId: id })
    }
    handleSelectCard = (groupId, typeId, icon) => {
        const { preRaceData, updateSelection } = this.props
        const drivingAggressive = preRaceData[ITEM.PRE_RACE_DRIVING_AGGRESIVE_THRESHOLD] || {}
        if (typeId === ITEM.PRE_RACE_DRIVING_AGGRESIVE && drivingAggressive.exceeded) {
            this.phaseRef.showModalErrorInfo('DRIVING_AGGRESSIVE_EXCEEDED', undefined, { threshold: drivingAggressive.threshold })
        } else {
            // console.log(`selectCard: ${groupId} - ${typeId}`)
            updateSelection(groupId, typeId)
            this.selectors = this.selectors.map(selector => {
                if (selector.id === groupId) return { ...selector, icon }
                return selector
            })
        }
    }
    handleSelectPitStops = selectionData => {
        const { credits, setCredits, updateSelection } = this.props
        const { error, groupId, typeId, currentUnits, nextUnits, currentTotalPrice, nextTotalPrice, deltaTotalPrice } = selectionData
        // console.log('setCardUnits: ', selectionData)
        if (error === 'CREDITS_EXCEED') {
            this.phaseRef.showModalErrorInfo('CREDITS_EXCEED_PITSTOP', () => this.setState({ allowPurchaseUnitsInDebt: true }))
        } else if (error) {
            this.phaseRef.showModalErrorInfo(error)
        } else {
            setCredits(credits + deltaTotalPrice)
            updateSelection(groupId, nextUnits)
        }
    }

    renderCardsGroup = ({ groupId, cards }) => {
        const { preRaceData, credits, selection, curvesParams, currentSelection } = this.props
        const { showAMToolPanel, allowPurchaseUnitsInDebt } = this.state
        return (
            <SubSectionPreRaceCardsGroup
                key={groupId}
                groupId={groupId}
                cards={cards}
                availableCredits={credits}
                selection={selection[groupId]}
                onSelect={this.handleSelectCard}
                onSelectPitStops={this.handleSelectPitStops}
                showAMToolPanel={showAMToolPanel}
                onToggleAMToolPanel={this.handleToggleAMToolPanel}
                curvesParams={curvesParams}
                currentSelection={currentSelection}
                numLaps={preRaceData.race.laps}
                lapLength={preRaceData.race.lapLength}
                allowPurchaseUnitsInDebt={allowPurchaseUnitsInDebt}
            />
        )
    }
    render() {
        const { phase, currentSeason, currentRace, totalRaces, preRaceData, t } = this.props
        const { selectedSelectorId } = this.state
        const anyIsSeleted = !!selectedSelectorId
        return phase === PHASE.PRE_RACE && (
            <Phase
                className="PreRace"
                phaseRef={this.setPhaseRef}
                showEndPhaseBtn={anyIsSeleted}
                interTitles={this.interTitles}
            >
                {preRaceData.race && (
                    <SectionPreRaceCircuitPanel
                        season={currentSeason}
                        race={currentRace}
                        totalRaces={totalRaces}
                        {...preRaceData.race}
                    />
                )}
                {/* <section className="Cards">
                    <Text>{t('game.PRE_RACE.cardsTitle')}</Text>
                </section> */}
                <section className={['PreRaceIntro', { Hide: anyIsSeleted }]}>
                    <Text dangerouslySetInnerHTML={{ __html: t('game.PRE_RACE.intro') }} />
                </section>
                <SectionAllCards groupIds={this.selectorsIds} selectedGroupId={selectedSelectorId}>
                    {this.cardsData.map(this.renderCardsGroup)}
                </SectionAllCards>
                <SectionSelectors
                    selectors={this.selectors}
                    selected={selectedSelectorId}
                    onSelect={this.handleSelectSelector}
                />
            </Phase>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/PreRace/PreRace.js